<ng-container *ngFor="let p of selects; let i = index">
  <mat-form-field class="select" appearance="outline">
    <mat-label>{{ this.config.label }} {{ 1 + i }}</mat-label>
    <input
      class="mat-form-field uppercase"
      matInput
      [attr.placeholder]="config.placeholder"
      [readonly]="true"
      [value]="p.value"
      (click)="openSelectCrud(i, p)"
    />
    <button
      *ngIf="p.value"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="clear(i, p)"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</ng-container>

<!-- [formGroup]="group" -->
<!-- [formControlName]="config.name" -->
